import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Subheader from 'material-ui/Subheader';
import { Paper } from 'material-ui';
import withTranslation from '../../../hoc/withTranslation';
import { fetchApp } from '../../../store/apps/actions';
import {
    getAchievement,
    putAchievement,
} from '../../../store/achievements/actions';
import Error from '../../../components/common/Error/Error';
import Loading from '../../../components/common/Loading/Loading';
import style from '../../../styles/styles';
import AchievementForm from '../../../components/achievement/AchievementForm/AchievementForm';
import { ACHIEVEMENT_PAGE } from '../../../constants/routes';
import { getCustomFields } from '../../../store/customfields/actions';
import CustomFieldService from '../../../services/customfield';

export class EditAchievementPage extends React.Component {
    static propTypes = {
        app: PropTypes.object,
        match: PropTypes.object,
        currentAchievement: PropTypes.object,
        currentLang: PropTypes.string,
        achievementsSending: PropTypes.bool,
        t: PropTypes.func,
        fetchApp: PropTypes.func,
        getAchievement: PropTypes.func,
        putAchievement: PropTypes.func,
        getCustomFields: PropTypes.func,
        customFields: PropTypes.arrayOf(PropTypes.object),
    };

    componentWillMount() {
        this.fetchApplication(this.props.match.params.appId);
    }

    componentWillReceiveProps(nextProps) {
        const lang = nextProps.currentLang;
        if ((
            this.props.match !== nextProps.match || !this.props.app
        ) && !nextProps.appPending) {
            this.fetchApplication(this.props.match.params.appId);
        }
        if (
            nextProps.app
            && !this.props.currentAchievement
            && !nextProps.currentAchievement
            && !nextProps.achievementsPending
        ) {
            this.props.getAchievement(nextProps.app, this.props.match.params.achievementId, lang);
        }
        if (nextProps.app && !nextProps.customFields) {
            this.props.getCustomFields(nextProps.app.id);
        }
    }

    componentWillUpdate(nextProps) {
        if (this.props.achievementsSending && !nextProps.achievementsSending) {
            nextProps.history.push(
                ACHIEVEMENT_PAGE
                    .replace(':appId', nextProps.app.id)
                    .replace(':achievementId', nextProps.currentAchievement.id)
            );
        }
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;
            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    handleFormSubmit = async (formProps) => {
        if (formProps === null) {
            return;
        }
        await this.props.putAchievement(this.props.app, formProps, this.props.currentLang)
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (
            this.props.appPending
            || this.props.achievementsPending
            || !this.props.app
            || !this.props.currentAchievement
        ) {
            return <Loading paper={false}/>;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>
                        {this.props.t('module.gamification.achievements')} / {this.props.t('generic.edit')} - {this.props.currentAchievement.name}
                    </h3>
                    <div className="row">
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper>
                                <Subheader style={style.subHeader}>
                                    {this.props.t('module.gamification.edit_achievement')}
                                </Subheader>
                                <div style={style.paper}>
                                    <AchievementForm
                                        app={this.props.app}
                                        onSubmit={this.handleFormSubmit}
                                        submitting={this.props.achievementsSending}
                                        initialValues={this.props.initialValues}
                                        customFields={CustomFieldService.filter(this.props.customFields,
                                            CustomFieldService.ACHIEVEMENT,
                                        )}
                                        defaultAcquisitionType={this.props.currentAchievement.acquisition_type}
                                    />
                                </div>
                            </Paper>
                        </div>
                    </div>
                </div>
            );
        }
    }
}


function mapStateToProps(state, ownProps) {
    let props = {
        appPending: state.apps.pending,
        error: state.apps.error || state.achievements.error,
        app: state.apps.currentApplication,
        achievementsPending: state.achievements.pending,
        currentAchievement: state.achievements.currentAchievement,
        achievementsSending: state.achievements.sending,
        currentLang: state.ui.currentLang,
        user: state.auth.content,
        customFields: state.customFields.content,
    };
    if (state.apps.currentApplication) {
        props.app = state.apps.currentApplication;
    }
    const achievement = state.achievements.currentAchievement;
    if (achievement) {
        let initValues = { ...achievement };
        if (achievement.custom_fields) {
            achievement.custom_fields.forEach((customField) => {
                initValues[customField.id] = customField.value;
            });
        }
        props.initialValues = initValues;
    }
    return props;
}

export default connect(
    mapStateToProps,
    {
        fetchApp,
        getAchievement,
        putAchievement,
        getCustomFields
    }
)(withRouter(withTranslation(EditAchievementPage)));




// WEBPACK FOOTER //
// src/containers/gamification/EditAchievementPage/EditAchievementPage.js